// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/rock-n-roll.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const rockNRoll: Score = {
  slug: "rock-n-roll",
  n: 19,
  title: "Rock 'n' Roll",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 108,
  staves: 2,
  clefs: ["treble", "bass"],
  bars: 29,
  barQuarters: 4.0,
  lowest: 36,
  highest: 79,
  hasLyrics: false,
  jasonNote: "Once you perfect this piece you will get all your friends and family tapping and dancing for sure!  Once you are done with this one, you are officially crowned a ROCKSTAR!",
  teaches: [
    "the blues crush - a flat third sounded against the fifth, resolving up to the natural third",
    "blue notes and chromatic passing tones with printed accidentals in an empty key signature",
    "a four-bar left-hand introduction played alone",
    "a driving shuffle bass in both hands together"
  ],
  art: "/sight-reading/art/rock-n-roll.jpg",
  artRights: "studio",
  background: "/sight-reading/bg/rock-n-roll.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 4.0, rest: true, d: "whole" },
    { bar: 1, hand: "lh", start: 0.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 1, hand: "lh", start: 0.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 1, hand: "lh", start: 1.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 1, hand: "lh", start: 1.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 1, hand: "lh", start: 2.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 1, hand: "lh", start: 2.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 1, hand: "lh", start: 3.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 1, hand: "lh", start: 3.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 2, hand: "rh", start: 4.0, dur: 4.0, rest: true, d: "whole" },
    { bar: 2, hand: "lh", start: 4.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 2, hand: "lh", start: 4.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 2, hand: "lh", start: 5.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 2, hand: "lh", start: 5.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 2, hand: "lh", start: 6.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 2, hand: "lh", start: 6.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 2, hand: "lh", start: 7.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 2, hand: "lh", start: 7.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 3, hand: "rh", start: 8.0, dur: 4.0, rest: true, d: "whole" },
    { bar: 3, hand: "lh", start: 8.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 3, hand: "lh", start: 8.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 3, hand: "lh", start: 9.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 3, hand: "lh", start: 9.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 3, hand: "lh", start: 10.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 3, hand: "lh", start: 10.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 3, hand: "lh", start: 11.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 3, hand: "lh", start: 11.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 4, hand: "rh", start: 12.0, dur: 4.0, rest: true, d: "whole" },
    { bar: 4, hand: "lh", start: 12.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 4, hand: "lh", start: 12.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 4, hand: "lh", start: 13.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 4, hand: "lh", start: 13.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 4, hand: "lh", start: 14.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 4, hand: "lh", start: 14.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 4, hand: "lh", start: 15.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 4, hand: "lh", start: 15.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 5, hand: "rh", start: 16.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 5, hand: "rh", start: 16.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 5, hand: "lh", start: 16.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 5, hand: "lh", start: 16.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 5, hand: "rh", start: 16.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 5, hand: "rh", start: 17.0, dur: 0.5, rest: true, d: "eighth" },
    { bar: 5, hand: "lh", start: 17.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 5, hand: "lh", start: 17.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 5, hand: "rh", start: 17.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 5, hand: "rh", start: 17.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 5, hand: "rh", start: 18.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 5, hand: "lh", start: 18.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 5, hand: "lh", start: 18.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 5, hand: "rh", start: 18.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 5, hand: "rh", start: 19.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 5, hand: "lh", start: 19.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 5, hand: "lh", start: 19.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 5, hand: "rh", start: 19.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 6, hand: "rh", start: 20.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 6, hand: "rh", start: 20.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 6, hand: "lh", start: 20.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 6, hand: "lh", start: 20.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 6, hand: "rh", start: 20.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 6, hand: "rh", start: 21.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 6, hand: "lh", start: 21.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 6, hand: "lh", start: 21.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 6, hand: "rh", start: 21.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 6, hand: "rh", start: 21.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 6, hand: "rh", start: 22.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 6, hand: "lh", start: 22.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 6, hand: "lh", start: 22.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 6, hand: "rh", start: 22.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 6, hand: "rh", start: 23.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 6, hand: "lh", start: 23.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 6, hand: "lh", start: 23.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 6, hand: "rh", start: 23.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 7, hand: "rh", start: 24.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 7, hand: "rh", start: 24.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 7, hand: "lh", start: 24.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 7, hand: "lh", start: 24.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 7, hand: "rh", start: 24.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 7, hand: "rh", start: 25.0, dur: 0.5, rest: true, d: "eighth" },
    { bar: 7, hand: "lh", start: 25.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 7, hand: "lh", start: 25.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 7, hand: "rh", start: 25.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 7, hand: "rh", start: 25.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 7, hand: "rh", start: 26.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 7, hand: "lh", start: 26.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 7, hand: "lh", start: 26.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 7, hand: "rh", start: 26.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 7, hand: "rh", start: 27.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 7, hand: "lh", start: 27.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 7, hand: "lh", start: 27.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 7, hand: "rh", start: 27.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 8, hand: "rh", start: 28.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 8, hand: "lh", start: 28.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 8, hand: "lh", start: 28.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 8, hand: "rh", start: 28.5, dur: 0.5, midi: 70, pitch: "Bb4", d: "eighth" },
    { bar: 8, hand: "rh", start: 29.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 8, hand: "lh", start: 29.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 8, hand: "lh", start: 29.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 8, hand: "rh", start: 29.5, dur: 0.5, midi: 66, pitch: "F#4", d: "eighth" },
    { bar: 8, hand: "rh", start: 30.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth" },
    { bar: 8, hand: "lh", start: 30.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 8, hand: "lh", start: 30.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 8, hand: "rh", start: 30.5, dur: 0.5, midi: 63, pitch: "Eb4", d: "eighth" },
    { bar: 8, hand: "rh", start: 31.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 8, hand: "lh", start: 31.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 8, hand: "lh", start: 31.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 8, hand: "rh", start: 31.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 9, hand: "rh", start: 32.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 9, hand: "rh", start: 32.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 9, hand: "lh", start: 32.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 9, hand: "lh", start: 32.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 9, hand: "rh", start: 32.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 9, hand: "rh", start: 33.0, dur: 0.5, rest: true, d: "eighth" },
    { bar: 9, hand: "lh", start: 33.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 9, hand: "lh", start: 33.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 9, hand: "rh", start: 33.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 9, hand: "rh", start: 33.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 9, hand: "rh", start: 34.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 9, hand: "lh", start: 34.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 9, hand: "lh", start: 34.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 9, hand: "rh", start: 34.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 9, hand: "rh", start: 35.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 9, hand: "lh", start: 35.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 9, hand: "lh", start: 35.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 9, hand: "rh", start: 35.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 10, hand: "rh", start: 36.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 10, hand: "rh", start: 36.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 10, hand: "lh", start: 36.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 10, hand: "lh", start: 36.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 10, hand: "rh", start: 36.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 10, hand: "rh", start: 37.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 10, hand: "lh", start: 37.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 10, hand: "lh", start: 37.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 10, hand: "rh", start: 37.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 10, hand: "rh", start: 37.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 10, hand: "rh", start: 38.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 10, hand: "lh", start: 38.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 10, hand: "lh", start: 38.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 10, hand: "rh", start: 38.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 10, hand: "rh", start: 39.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 10, hand: "lh", start: 39.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 10, hand: "lh", start: 39.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 10, hand: "rh", start: 39.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 11, hand: "rh", start: 40.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 11, hand: "rh", start: 40.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 11, hand: "lh", start: 40.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 11, hand: "lh", start: 40.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 11, hand: "rh", start: 40.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 11, hand: "rh", start: 41.0, dur: 0.5, rest: true, d: "eighth" },
    { bar: 11, hand: "lh", start: 41.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 11, hand: "lh", start: 41.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 11, hand: "rh", start: 41.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 11, hand: "rh", start: 41.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 11, hand: "rh", start: 42.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 11, hand: "lh", start: 42.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 11, hand: "lh", start: 42.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 11, hand: "rh", start: 42.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 11, hand: "rh", start: 43.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 11, hand: "lh", start: 43.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 11, hand: "lh", start: 43.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 11, hand: "rh", start: 43.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 12, hand: "rh", start: 44.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 12, hand: "lh", start: 44.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 12, hand: "lh", start: 44.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 12, hand: "rh", start: 44.5, dur: 0.5, midi: 70, pitch: "Bb4", d: "eighth" },
    { bar: 12, hand: "rh", start: 45.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 12, hand: "lh", start: 45.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 12, hand: "lh", start: 45.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 12, hand: "rh", start: 45.5, dur: 0.5, midi: 66, pitch: "F#4", d: "eighth" },
    { bar: 12, hand: "rh", start: 46.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth" },
    { bar: 12, hand: "lh", start: 46.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 12, hand: "lh", start: 46.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 12, hand: "rh", start: 46.5, dur: 0.5, midi: 63, pitch: "Eb4", d: "eighth" },
    { bar: 12, hand: "rh", start: 47.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 12, hand: "lh", start: 47.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 12, hand: "lh", start: 47.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 12, hand: "rh", start: 47.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 13, hand: "rh", start: 48.0, dur: 0.5, midi: 68, pitch: "Ab4", d: "eighth" },
    { bar: 13, hand: "lh", start: 48.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 13, hand: "lh", start: 48.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter", chord: true },
    { bar: 13, hand: "rh", start: 48.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 13, hand: "rh", start: 49.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 13, hand: "lh", start: 49.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 13, hand: "lh", start: 49.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter", chord: true },
    { bar: 13, hand: "rh", start: 49.5, dur: 0.5, midi: 68, pitch: "Ab4", d: "eighth" },
    { bar: 13, hand: "rh", start: 50.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 13, hand: "lh", start: 50.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 13, hand: "lh", start: 50.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter", chord: true },
    { bar: 13, hand: "rh", start: 50.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 13, hand: "rh", start: 51.0, dur: 0.5, midi: 68, pitch: "Ab4", d: "eighth" },
    { bar: 13, hand: "lh", start: 51.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 13, hand: "lh", start: 51.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter", chord: true },
    { bar: 13, hand: "rh", start: 51.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 14, hand: "rh", start: 52.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 14, hand: "lh", start: 52.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 14, hand: "lh", start: 52.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter", chord: true },
    { bar: 14, hand: "rh", start: 52.5, dur: 0.5, midi: 68, pitch: "Ab4", d: "eighth" },
    { bar: 14, hand: "rh", start: 53.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 14, hand: "lh", start: 53.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 14, hand: "lh", start: 53.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter", chord: true },
    { bar: 14, hand: "rh", start: 53.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 14, hand: "rh", start: 54.0, dur: 0.5, midi: 68, pitch: "Ab4", d: "eighth" },
    { bar: 14, hand: "lh", start: 54.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 14, hand: "lh", start: 54.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter", chord: true },
    { bar: 14, hand: "rh", start: 54.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 14, hand: "rh", start: 55.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 14, hand: "lh", start: 55.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 14, hand: "lh", start: 55.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter", chord: true },
    { bar: 15, hand: "rh", start: 56.0, dur: 0.5, midi: 68, pitch: "Ab4", d: "eighth" },
    { bar: 15, hand: "lh", start: 56.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 15, hand: "lh", start: 56.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 15, hand: "rh", start: 56.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 15, hand: "rh", start: 57.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 15, hand: "lh", start: 57.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 15, hand: "lh", start: 57.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 15, hand: "rh", start: 57.5, dur: 0.5, midi: 68, pitch: "Ab4", d: "eighth" },
    { bar: 15, hand: "rh", start: 58.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 15, hand: "lh", start: 58.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 15, hand: "lh", start: 58.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 15, hand: "rh", start: 58.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 15, hand: "rh", start: 59.0, dur: 0.5, midi: 68, pitch: "Ab4", d: "eighth" },
    { bar: 15, hand: "lh", start: 59.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 15, hand: "lh", start: 59.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 15, hand: "rh", start: 59.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 16, hand: "rh", start: 60.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 16, hand: "lh", start: 60.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 16, hand: "lh", start: 60.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 16, hand: "rh", start: 60.5, dur: 0.5, midi: 68, pitch: "Ab4", d: "eighth" },
    { bar: 16, hand: "rh", start: 61.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 16, hand: "lh", start: 61.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 16, hand: "lh", start: 61.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 16, hand: "rh", start: 61.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 16, hand: "rh", start: 62.0, dur: 0.5, midi: 68, pitch: "Ab4", d: "eighth" },
    { bar: 16, hand: "lh", start: 62.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 16, hand: "lh", start: 62.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 16, hand: "rh", start: 62.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 16, hand: "rh", start: 63.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 16, hand: "lh", start: 63.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 16, hand: "lh", start: 63.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 17, hand: "rh", start: 64.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 17, hand: "rh", start: 64.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 17, hand: "lh", start: 64.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 17, hand: "lh", start: 64.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 17, hand: "rh", start: 64.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 17, hand: "rh", start: 65.0, dur: 0.5, rest: true, d: "eighth" },
    { bar: 17, hand: "lh", start: 65.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 17, hand: "lh", start: 65.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 17, hand: "rh", start: 65.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 17, hand: "rh", start: 65.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 17, hand: "rh", start: 66.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 17, hand: "lh", start: 66.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 17, hand: "lh", start: 66.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 17, hand: "rh", start: 66.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 17, hand: "rh", start: 67.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 17, hand: "lh", start: 67.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 17, hand: "lh", start: 67.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 17, hand: "rh", start: 67.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 18, hand: "rh", start: 68.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 18, hand: "rh", start: 68.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 18, hand: "lh", start: 68.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 18, hand: "lh", start: 68.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 18, hand: "rh", start: 68.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 18, hand: "rh", start: 69.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 18, hand: "lh", start: 69.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 18, hand: "lh", start: 69.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 18, hand: "rh", start: 69.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 18, hand: "rh", start: 69.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 18, hand: "rh", start: 70.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 18, hand: "lh", start: 70.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 18, hand: "lh", start: 70.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 18, hand: "rh", start: 70.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 18, hand: "rh", start: 71.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 18, hand: "lh", start: 71.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 18, hand: "lh", start: 71.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 18, hand: "rh", start: 71.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 19, hand: "rh", start: 72.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 19, hand: "rh", start: 72.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 19, hand: "lh", start: 72.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 19, hand: "lh", start: 72.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 19, hand: "rh", start: 72.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 19, hand: "rh", start: 73.0, dur: 0.5, rest: true, d: "eighth" },
    { bar: 19, hand: "lh", start: 73.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 19, hand: "lh", start: 73.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 19, hand: "rh", start: 73.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 19, hand: "rh", start: 73.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 19, hand: "rh", start: 74.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 19, hand: "lh", start: 74.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 19, hand: "lh", start: 74.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 19, hand: "rh", start: 74.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 19, hand: "rh", start: 75.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 19, hand: "lh", start: 75.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 19, hand: "lh", start: 75.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 19, hand: "rh", start: 75.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 20, hand: "rh", start: 76.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 20, hand: "lh", start: 76.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 20, hand: "lh", start: 76.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 20, hand: "rh", start: 76.5, dur: 0.5, midi: 70, pitch: "Bb4", d: "eighth" },
    { bar: 20, hand: "rh", start: 77.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 20, hand: "lh", start: 77.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 20, hand: "lh", start: 77.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 20, hand: "rh", start: 77.5, dur: 0.5, midi: 66, pitch: "F#4", d: "eighth" },
    { bar: 20, hand: "rh", start: 78.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth" },
    { bar: 20, hand: "lh", start: 78.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 20, hand: "lh", start: 78.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 20, hand: "rh", start: 78.5, dur: 0.5, midi: 63, pitch: "Eb4", d: "eighth" },
    { bar: 20, hand: "rh", start: 79.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 20, hand: "lh", start: 79.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 20, hand: "lh", start: 79.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 20, hand: "rh", start: 79.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 21, hand: "rh", start: 80.0, dur: 0.5, midi: 70, pitch: "Bb4", d: "eighth" },
    { bar: 21, hand: "lh", start: 80.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 21, hand: "lh", start: 80.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 21, hand: "rh", start: 80.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 21, hand: "rh", start: 81.0, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 21, hand: "lh", start: 81.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 21, hand: "lh", start: 81.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", chord: true },
    { bar: 21, hand: "rh", start: 81.5, dur: 0.5, midi: 70, pitch: "Bb4", d: "eighth" },
    { bar: 21, hand: "rh", start: 82.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 21, hand: "lh", start: 82.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 21, hand: "lh", start: 82.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 21, hand: "rh", start: 82.5, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 21, hand: "rh", start: 83.0, dur: 0.5, midi: 70, pitch: "Bb4", d: "eighth" },
    { bar: 21, hand: "lh", start: 83.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 21, hand: "lh", start: 83.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", chord: true },
    { bar: 21, hand: "rh", start: 83.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 22, hand: "rh", start: 84.0, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 22, hand: "lh", start: 84.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 22, hand: "lh", start: 84.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 22, hand: "rh", start: 84.5, dur: 0.5, midi: 70, pitch: "Bb4", d: "eighth" },
    { bar: 22, hand: "rh", start: 85.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 22, hand: "lh", start: 85.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 22, hand: "lh", start: 85.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", chord: true },
    { bar: 22, hand: "rh", start: 85.5, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 22, hand: "rh", start: 86.0, dur: 0.5, midi: 70, pitch: "Bb4", d: "eighth" },
    { bar: 22, hand: "lh", start: 86.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 22, hand: "lh", start: 86.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 22, hand: "rh", start: 86.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 22, hand: "rh", start: 87.0, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 22, hand: "lh", start: 87.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 22, hand: "lh", start: 87.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", chord: true },
    { bar: 22, hand: "rh", start: 87.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 23, hand: "rh", start: 88.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 23, hand: "rh", start: 88.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", chord: true },
    { bar: 23, hand: "lh", start: 88.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 23, hand: "lh", start: 88.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 23, hand: "rh", start: 89.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 23, hand: "lh", start: 89.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 23, hand: "rh", start: 90.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 23, hand: "rh", start: 90.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", chord: true },
    { bar: 23, hand: "lh", start: 90.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 23, hand: "lh", start: 90.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 23, hand: "rh", start: 91.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 23, hand: "lh", start: 91.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 24, hand: "rh", start: 92.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 24, hand: "rh", start: 92.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", chord: true },
    { bar: 24, hand: "lh", start: 92.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 24, hand: "lh", start: 92.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 24, hand: "rh", start: 93.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 24, hand: "rh", start: 93.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", chord: true },
    { bar: 24, hand: "lh", start: 93.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 24, hand: "lh", start: 93.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 24, hand: "rh", start: 94.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 24, hand: "rh", start: 94.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", chord: true },
    { bar: 24, hand: "lh", start: 94.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 24, hand: "lh", start: 94.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 24, hand: "rh", start: 95.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 24, hand: "rh", start: 95.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", chord: true },
    { bar: 24, hand: "lh", start: 95.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 24, hand: "lh", start: 95.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", chord: true },
    { bar: 25, hand: "rh", start: 96.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 25, hand: "rh", start: 96.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 25, hand: "lh", start: 96.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 25, hand: "lh", start: 96.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 25, hand: "rh", start: 96.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 25, hand: "rh", start: 97.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 25, hand: "lh", start: 97.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 25, hand: "lh", start: 97.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 25, hand: "rh", start: 97.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 25, hand: "rh", start: 97.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 25, hand: "rh", start: 98.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 25, hand: "lh", start: 98.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 25, hand: "lh", start: 98.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 25, hand: "rh", start: 98.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 25, hand: "rh", start: 99.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 25, hand: "lh", start: 99.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 25, hand: "lh", start: 99.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter", chord: true },
    { bar: 25, hand: "rh", start: 99.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 26, hand: "rh", start: 100.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 26, hand: "rh", start: 100.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 26, hand: "lh", start: 100.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    {
  bar: 26,
  hand: "lh",
  start: 100.0,
  dur: 1.0,
  midi: 55,
  pitch: "G3",
  d: "quarter",
  chord: true
},
    { bar: 26, hand: "rh", start: 100.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 26, hand: "rh", start: 101.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 26, hand: "lh", start: 101.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    {
  bar: 26,
  hand: "lh",
  start: 101.0,
  dur: 1.0,
  midi: 57,
  pitch: "A3",
  d: "quarter",
  chord: true
},
    { bar: 26, hand: "rh", start: 101.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 26, hand: "rh", start: 101.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 26, hand: "rh", start: 102.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 26, hand: "lh", start: 102.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    {
  bar: 26,
  hand: "lh",
  start: 102.0,
  dur: 1.0,
  midi: 55,
  pitch: "G3",
  d: "quarter",
  chord: true
},
    { bar: 26, hand: "rh", start: 102.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 26, hand: "rh", start: 103.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 26, hand: "lh", start: 103.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    {
  bar: 26,
  hand: "lh",
  start: 103.0,
  dur: 1.0,
  midi: 57,
  pitch: "A3",
  d: "quarter",
  chord: true
},
    { bar: 26, hand: "rh", start: 103.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 27, hand: "rh", start: 104.0, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 27, hand: "rh", start: 104.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 27, hand: "lh", start: 104.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    {
  bar: 27,
  hand: "lh",
  start: 104.0,
  dur: 1.0,
  midi: 55,
  pitch: "G3",
  d: "quarter",
  chord: true
},
    { bar: 27, hand: "rh", start: 104.5, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 27, hand: "rh", start: 105.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 27, hand: "lh", start: 105.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    {
  bar: 27,
  hand: "lh",
  start: 105.0,
  dur: 1.0,
  midi: 57,
  pitch: "A3",
  d: "quarter",
  chord: true
},
    { bar: 27, hand: "rh", start: 105.5, dur: 0.5, midi: 75, pitch: "Eb5", d: "eighth" },
    { bar: 27, hand: "rh", start: 105.5, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", chord: true },
    { bar: 27, hand: "rh", start: 106.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 27, hand: "lh", start: 106.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    {
  bar: 27,
  hand: "lh",
  start: 106.0,
  dur: 1.0,
  midi: 55,
  pitch: "G3",
  d: "quarter",
  chord: true
},
    { bar: 27, hand: "rh", start: 106.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 27, hand: "rh", start: 107.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 27, hand: "lh", start: 107.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    {
  bar: 27,
  hand: "lh",
  start: 107.0,
  dur: 1.0,
  midi: 57,
  pitch: "A3",
  d: "quarter",
  chord: true
},
    { bar: 27, hand: "rh", start: 107.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 28, hand: "rh", start: 108.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    {
  bar: 28,
  hand: "rh",
  start: 108.0,
  dur: 1.0,
  midi: 67,
  pitch: "G4",
  d: "quarter",
  chord: true
},
    {
  bar: 28,
  hand: "rh",
  start: 108.0,
  dur: 1.0,
  midi: 72,
  pitch: "C5",
  d: "quarter",
  chord: true
},
    { bar: 28, hand: "lh", start: 108.0, dur: 1.0, midi: 36, pitch: "C2", d: "quarter" },
    {
  bar: 28,
  hand: "lh",
  start: 108.0,
  dur: 1.0,
  midi: 48,
  pitch: "C3",
  d: "quarter",
  chord: true
},
    { bar: 28, hand: "rh", start: 109.0, dur: 0.5, rest: true, d: "eighth" },
    { bar: 28, hand: "lh", start: 109.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 28,
  hand: "rh",
  start: 109.5,
  dur: 0.5,
  midi: 60,
  pitch: "C4",
  d: "eighth",
  tie: "start"
},
    { bar: 28, hand: "rh", start: 109.5, dur: 0.5, midi: 64, pitch: "E4", d: "eighth", chord: true },
    { bar: 28, hand: "rh", start: 109.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", chord: true },
    { bar: 28, hand: "rh", start: 109.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth", chord: true },
    {
  bar: 28,
  hand: "lh",
  start: 109.5,
  dur: 0.5,
  midi: 36,
  pitch: "C2",
  d: "eighth",
  tie: "start"
},
    { bar: 28, hand: "lh", start: 109.5, dur: 0.5, midi: 48, pitch: "C3", d: "eighth", chord: true },
    { bar: 28, hand: "rh", start: 110.0, dur: 2.0, midi: 60, pitch: "C4", d: "half", tie: "both" },
    { bar: 28, hand: "rh", start: 110.0, dur: 2.0, midi: 64, pitch: "E4", d: "half", chord: true },
    { bar: 28, hand: "rh", start: 110.0, dur: 2.0, midi: 67, pitch: "G4", d: "half", chord: true },
    { bar: 28, hand: "rh", start: 110.0, dur: 2.0, midi: 72, pitch: "C5", d: "half", chord: true },
    { bar: 28, hand: "lh", start: 110.0, dur: 2.0, midi: 36, pitch: "C2", d: "half", tie: "both" },
    { bar: 28, hand: "lh", start: 110.0, dur: 2.0, midi: 48, pitch: "C3", d: "half", chord: true },
    { bar: 29, hand: "rh", start: 112.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole", tie: "stop" },
    { bar: 29, hand: "rh", start: 112.0, dur: 4.0, midi: 64, pitch: "E4", d: "whole", chord: true },
    { bar: 29, hand: "rh", start: 112.0, dur: 4.0, midi: 67, pitch: "G4", d: "whole", chord: true },
    { bar: 29, hand: "rh", start: 112.0, dur: 4.0, midi: 72, pitch: "C5", d: "whole", chord: true },
    { bar: 29, hand: "lh", start: 112.0, dur: 2.0, midi: 36, pitch: "C2", d: "half", tie: "stop" },
    { bar: 29, hand: "lh", start: 112.0, dur: 2.0, midi: 48, pitch: "C3", d: "half", chord: true },
    { bar: 29, hand: "lh", start: 114.0, dur: 2.0, rest: true, d: "half" },
  ],
};
